import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ContenedorConstanciasAlumnos.css';
import {
  certificateApi,
  certificateDownloadUrl,
} from '../../services/certificateApi';
import { useData } from '../Pages/DataContext';

const DownloadIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M12 3v12m0 0 5-5m-5 5-5-5M5 21h14" />
  </svg>
);

const CertificateIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M7 3h7l5 5v7M14 3v5h5M8 13h6M8 17h4" />
    <path d="M6 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
    <path d="m18 17 .8 1.6 1.7.3-1.2 1.3.3 1.8-1.6-.8-1.6.8.3-1.8-1.2-1.3 1.7-.3L18 17Z" />
  </svg>
);

const ContenedorConstanciasAlumnos = () => {
  const { data } = useData();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const loadCertificates = async () => {
      if (!data?.matricula) {
        setCertificates([]);
        setLoading(false);
        return;
      }

      try {
        const items = await certificateApi.listMine(data.matricula);
        if (active) {
          setCertificates(Array.isArray(items) ? items : []);
          setError('');
        }
      } catch (requestError) {
        if (active) {
          setCertificates([]);
          setError(
            'No pudimos cargar tus constancias. Intenta nuevamente más tarde.',
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    setLoading(true);
    loadCertificates();
    return () => {
      active = false;
    };
  }, [data?.matricula]);

  if (loading) {
    return (
      <div className="constancias-inicio-estado" aria-live="polite">
        <span className="constancias-inicio-cargador" />
        <strong>Cargando constancias</strong>
      </div>
    );
  }

  if (certificates.length === 0 && !error) {
    return (
      <div className="constancias-inicio-estado">
        <span className="constancias-inicio-icono constancias-inicio-icono-vacio">
          <CertificateIcon />
        </span>
        <strong>Aún no tienes constancias disponibles</strong>
        <p>Cuando se genere una para tu matrícula, aparecerá aquí.</p>
      </div>
    );
  }

  return (
    <div className="constancias-inicio">
      <div className="constancias-inicio-resumen">
        <span>Documentos académicos</span>
        <strong>
          {certificates.length}{' '}
          {certificates.length === 1
            ? 'constancia disponible'
            : 'constancias disponibles'}
        </strong>
      </div>

      {error && (
        <div className="constancias-inicio-error" role="alert">
          {error}
        </div>
      )}

      <div className="constancias-inicio-lista">
        {certificates.map((certificate) => (
          <article
            className="constancia-inicio-card"
            key={certificate.source + '-' + certificate.id}
          >
            <span className="constancias-inicio-icono">
              <CertificateIcon />
            </span>
            <div className="constancia-inicio-datos">
              <span>
                {certificate.source === 'legacy'
                  ? 'Documento heredado'
                  : 'Constancia académica'}
              </span>
              <h3 title={certificate.name}>{certificate.name}</h3>
              {certificate.training && <p>{certificate.training}</p>}
            </div>
            <div className="constancia-inicio-acciones">
              {certificate.validation_token && (
                <Link
                  className="constancia-inicio-validar"
                  to={
                    '/validar-constancia/' +
                    encodeURIComponent(certificate.validation_token)
                  }
                >
                  Validar
                </Link>
              )}
              <a
                className="constancia-inicio-descargar"
                href={certificateDownloadUrl(certificate.download_url)}
              >
                <DownloadIcon />
                Descargar
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ContenedorConstanciasAlumnos;
